import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

class ScrollToTop extends Component {
  componentDidMount() {
    const { location } = this.props;
    ReactGA.initialize('UA-171276564-29');
    ReactGA.pageview(location.pathname + location.search);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    ReactGA.initialize('UA-171276564-29');
    ReactGA.pageview(location.pathname + location.search);
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  location: PropTypes.shape().isRequired,
};

export default withRouter(ScrollToTop);
